export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/trampolinelife_ncl/',
  tiktok: 'https://www.tiktok.com/@trampolinelifencl',
  facebook: 'https://www.facebook.com/trampolinelife/',
  whatsapp: 'https://wa.me/447700149040',
};

